import React from "react";
import { Link } from "react-router-dom";
import FontAwesome from "react-fontawesome";

const Renderbooking = ({
  lastBookElementRef,
  list,
  snackMessage,
  handleOnClick,
}) => {
  //  console.log(list);
  return (
    <>
      {list &&
        list.map((item, index) => {
          if (list.length === index + 1) {
            return (
              <div className="row" ref={lastBookElementRef} key={item.no}>
                    <div className="container-fluid">
                  <div className="card border-secondary mt-1">
                   
                      <div className="row ms-1">
                        <div className="container col-xs-12 col-sm-4">
                          <div
                            className="border-top"
                            style={{ fontSize: "15px" }}
                          >
                            <span className="badge rounded-pill bg-secondary">
                              {item.no}
                            </span>
                          </div>
                          <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"ชื่อ:"} {item.fname} {" "} {item.lname}
                          </div>                                 
                        </div>

                        <div className="container col-xs-12 col-sm-4">

                        <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"บริษัท:"} {item.comname}
                          </div> 
                          <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            <span style={{ fontSize: "14px" }}>
                              {"mobile:"} {item.mobile}
                            </span>
                          </div>
                        

                     
                        </div>

                        <div className="container col-xs-12 col-sm-4">
                          <div
                            className="border-bottom"
                            style={{ fontSize: "14px" }}
                          >
                            <span style={{ fontSize: "15px" }}>
                              {"วันที่จอง:"}  <span className="badge rounded-pill bg-warning">
                                  {item.bookingdate}
                                </span>
                            
                            </span>
                          </div>                
                        </div>
                      </div>
                   
                  </div>
                </div>
         
              </div>
            );
          } else {
            return (
              <div className="row" key={item.no}>
                <div className="container-fluid">
                  <div className="card border-secondary mt-1">
                   
                      <div className="row ms-1">
                        <div className="container col-xs-12 col-sm-4">
                          <div
                            className="border-top"
                            style={{ fontSize: "15px" }}
                          >
                            <span className="badge rounded-pill bg-secondary">
                              {item.no}
                            </span>
                          </div>
                          <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"ชื่อ:"} {item.fname} {" "} {item.lname}
                          </div>                                 
                        </div>

                        <div className="container col-xs-12 col-sm-4">

                        <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            {"บริษัท:"} {item.comname}
                          </div> 
                          <div
                            className="border-top"
                            style={{ fontSize: "14px" }}
                          >
                            <span style={{ fontSize: "14px" }}>
                              {"mobile:"} {item.mobile}
                            </span>
                          </div>
                        

                     
                        </div>

                        <div className="container col-xs-12 col-sm-4">
                          <div
                            className="border-bottom"
                            style={{ fontSize: "14px" }}
                          >
                            <span style={{ fontSize: "15px" }}>
                              {"วันที่จอง:"}  <span className="badge rounded-pill bg-warning"> 
                                  {item.bookingdate}
                                </span>
                            
                            </span>
                          </div>                
                        </div>
                      </div>
                   
                  </div>
                </div>
              </div>
            );
          }
        })}
    </>
  );
};

export default Renderbooking;
